import React, { useState, useEffect } from "react";
import { ref, getDatabase, get } from "firebase/database";

function TablePickerPopup({ ownerId, onSelect, onNoTable, onCancel }) {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const db = getDatabase();

  useEffect(() => {
    if (!ownerId) { setLoading(false); return; }
    get(ref(db, `tables/${ownerId}`)).then((snap) => {
      if (snap.exists()) {
        setTables(Object.values(snap.val()));
      }
      setLoading(false);
    });
  }, [db, ownerId]);

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40">
      <div className="bg-white rounded-t-3xl w-full max-w-md shadow-xl flex flex-col mb-16" style={{ maxHeight: "75vh" }}>
        {/* Header */}
        <div className="flex items-center justify-between px-5 pt-5 pb-4 flex-shrink-0">
          <h3 className="text-base font-bold text-gray-900">Assign a Table</h3>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 text-xl leading-none"
          >
            ×
          </button>
        </div>

        {/* Scrollable table grid */}
        <div className="flex-1 overflow-y-auto px-5">
          {loading ? (
            <p className="text-sm text-gray-400 text-center py-6">Loading…</p>
          ) : tables.length === 0 ? (
            <p className="text-sm text-gray-400 text-center py-6">
              No tables configured.
            </p>
          ) : (
            <div className="grid grid-cols-3 gap-3 pb-4">
              {tables.map((table) => {
                const isFree = table.status === "free";
                return (
                  <button
                    key={table.id}
                    onClick={() => isFree && onSelect(table)}
                    disabled={!isFree}
                    className={`flex flex-col items-center justify-center rounded-2xl py-4 border-2 transition-colors ${
                      isFree
                        ? "border-green-200 bg-green-50 text-green-700 hover:bg-green-100"
                        : "border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed"
                    }`}
                  >
                    <span className="text-2xl font-bold">{table.number}</span>
                    {table.label && (
                      <span className="text-xs mt-0.5 truncate max-w-full px-1">
                        {table.label}
                      </span>
                    )}
                    {table.capacity && (
                      <span className="text-xs opacity-60">{table.capacity} seats</span>
                    )}
                    <span className={`text-xs font-semibold mt-1 ${isFree ? "text-green-600" : "text-gray-300"}`}>
                      {isFree ? "Free" : "Busy"}
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {/* Sticky bottom button */}
        <div className="px-5 pt-3 pb-4 flex-shrink-0 border-t border-gray-100">
          <button
            onClick={onNoTable}
            className="w-full py-3 rounded-xl border border-gray-200 text-gray-600 text-sm font-semibold"
          >
            Check in without table
          </button>
        </div>
      </div>
    </div>
  );
}

export default TablePickerPopup;
